//import images
import kangaroo1 from './img/projects/kangaroo1.jpg';
import kangaroo2 from './img/projects/kangaroo2.jpg';
import iphoneseven1 from './img/projects/iphoneseven1.gif';
import iphoneseven2 from './img/projects/iphoneseven.png';
import spidermonkey1 from './img/projects/spider-monkey1.png';
import spidermonkey2 from './img/projects/spider-monkey2.jpg';
import scleton1 from './img/projects/scleton1.jpg';
import scleton2 from './img/projects/scleton2.jpg';
import lunch1 from './img/projects/lunch1.png';
import lunch2 from './img/projects/lunch2.jpg';
import houseautmn1 from './img/projects/house-autmn1.jpg';
import houseautmn2 from './img/projects/house-autmn2.jpg';
import dragon1 from './img/projects/dragon1.jpg';
import dragon2 from './img/projects/dragon2.jpg';
import robocom1 from './img/projects/robocom1.jpg';
import robocom2 from './img/projects/robocom2.jpg';
import dormammoo1 from './img/projects/dormammoo1.jpg';
import dormammoo2 from './img/projects/dormammoo2.jpg';
import cyberpunkjacket1 from './img/projects/cyberpunk-jacket1.jpg';
import cyberpunkjacket2 from './img/projects/cyberpunk-jacket2.jpg';
import castle1 from './img/projects/castle1.jpg';
import castle2 from './img/projects/castle2.jpg';
import bedroom1 from './img/projects/bedroom1.png';
import bedroom2 from './img/projects/bedroom2.png';
import shark1 from './img/projects/shark1.jpg'
import shark2 from './img/projects/shark2.jpg'
import parkingplace1 from './img/projects/parkingplace1.jpg'
import parkingplace2 from './img/projects/parkingplace2.jpg'
import oldtavern1 from './img/projects/oldtavern1.jpg'
import oldtavern2 from './img/projects/oldtavern2.jpg'

export const MovieState = () => {
  return [
    {
      name: 'Old Tavern',
      mainImg: oldtavern1,
      secondaryImg: oldtavern2,
      url: '/projects/oldtavern',
      type: 'photo',
      id: 14,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Parking Place',
      mainImg: parkingplace1,
      secondaryImg: parkingplace2,
      url: '/projects/parkingplace',
      type: 'photo',
      id: 13,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Shark',
      mainImg: shark1,
      secondaryImg: shark2,
      url: '/projects/shark',
      type: 'photo',
      id: 12,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Bedroom',
      mainImg: bedroom1,
      secondaryImg: bedroom2,
      url: '/projects/bedroom',
      type: 'photo',
      id: 11,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Castle',
      mainImg: castle1,
      secondaryImg: castle2,
      url: '/projects/castle',
      type: 'photo',
      id: 10,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Cyberpunk Jacket',
      mainImg: cyberpunkjacket1,
      secondaryImg: cyberpunkjacket2,
      url: '/projects/cyberpunkjacket',
      type: 'photo',
      id: 9,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Cinematic Set Design',
      mainImg: dormammoo1,
      secondaryImg: dormammoo2,
      url: '/projects/cinematicsetdesign',
      type: 'photo',
      id: 8,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Scifi Robot',
      mainImg: robocom1,
      secondaryImg: robocom2,
      url: '/projects/scifirobot',
      type: 'photo',
      id: 7,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Golden Dragon',
      mainImg: dragon1,
      secondaryImg: dragon2,
      url: '/projects/goldendragon',
      type: 'photo',
      id: 6,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Autmn Environment',
      mainImg: houseautmn1,
      secondaryImg: houseautmn2,
      url: '/projects/houseautmn',
      type: 'photo',
      id: 5,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Restourant in Garden',
      mainImg: lunch1,
      secondaryImg: lunch2,
      url: '/projects/garden',
      type: 'photo',
      id: 4,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Particle Man',
      mainImg: scleton1,
      secondaryImg: scleton2,
      url: '/projects/scleton',
      type: 'photo',
      id: 3,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'Spider Monkey',
      mainImg: spidermonkey1,
      secondaryImg: spidermonkey2,
      url: '/projects/spidermonkey',
      type: 'photo',
      id: 2,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
    {
      name: 'iPhone Trailer',
      mainImg: iphoneseven1,
      secondaryImg: iphoneseven2,
      url: '/projects/iphoneseven',
      type: 'video',
      id: 1,
      awards: [
        {
          title: 'About Project',
          description:
            'The video was made as an alternative to the iPhone trailer. Different color phone models were used in the animation.',
        },
        {
          title: 'What I did',
          description:
            'The prototype of the video can be used to make other commercials.',
        },
      ],
    },
    {
      name: 'Kangaroo',
      mainImg: kangaroo1,
      secondaryImg: kangaroo2,
      url: '/projects/kangaroo',
      type: 'photo',
      id: 0,
      awards: [
        {
          title: 'About Project',
          description:
            'This model can be used in the field of cinematography, game applications. The model`s grid is low poly.',
        },
        {
          title: 'What I did',
          description:
            'This model used a particle system and was created in 1 day. The part has been edited and colored in a realistic way.',
        },
      ],
    },
  ];
};

export default MovieState;
